import { render, staticRenderFns } from "./vidHotQuery.vue?vue&type=template&id=27bec760&scoped=true&"
import script from "./vidHotQuery.vue?vue&type=script&lang=js&"
export * from "./vidHotQuery.vue?vue&type=script&lang=js&"
import style0 from "./vidHotQuery.vue?vue&type=style&index=0&id=27bec760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bec760",
  null
  
)

export default component.exports